export default () => ({
  partners: ["20fc4348-f8cc-4e59-beef-6723c6d302a9"],
});
